import React from 'react';
import { InputRow } from '../../../helpers/uiComponents/InputRow';

class StepTwo extends React.Component {
    render() {
        const data = this.props.data;
        const doFunction = this.props.doFunction;

        return(
            <React.Fragment>
                {(data && data.length > 0) ? (
                    <React.Fragment>
                    <h4>2. Select a Promotion/Email Campaign.</h4>
                    <p><small>In order to select a promotion...<br/>
                        A: the Promotion or Email Campaign must have at least one Email Series created<br/>
                        B: the selected client MUST be assigned to at least one of ANY widget <em>(email series, slides, banners, landing pages, etc...)</em> within the promotion or email campaign.</small></p>
                    <InputRow label="Promotion Name*" type="select" options={data} id="promoCode" onChange={doFunction} />
                    </React.Fragment>
                ) : (
                    <p style={{"textAlign": "center","color": "red"}}>The chosen client is not assigned to any Promotions that have email events available for testing..</p>
                )}
            </React.Fragment>
        )
    }
}
export default StepTwo;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/TestSteps/StepTwo.js